<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <FirstTimeInfoModal
    :show="show"
    :title="$t('views.goats.prefixInfo.title')"
    :subtitle="$t('views.goats.prefixInfo.subtitle')"
    :message="$t('views.goats.prefixInfo.message')"
    :example="'DE 0123 456'"
    :setupLabel="$t('views.goats.prefixInfo.setupNow')"
    :continueLabel="$t('views.goats.prefixInfo.continueWithout')"
    @update:show="$emit('update:show', $event)"
    @setup="handleSetup"
    @continue="handleContinue" />
</template>

<script setup>
  import { useRouter } from 'vue-router'
  import FirstTimeInfoModal from '@/components/ui/feedback/FirstTimeInfoModal.vue'

  const router = useRouter()

  defineProps({
    show: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['update:show', 'setup-prefix', 'continue'])

  function handleSetup(dontShowAgain) {
    emit('setup-prefix', dontShowAgain)
    router.push('/more/eartag-prefix')
  }

  function handleContinue(dontShowAgain) {
    emit('continue', dontShowAgain)
  }
</script>
